import { render } from "./card.vue?vue&type=template&id=a15e4d8c&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"

import "./card.vue?vue&type=style&index=0&id=a15e4d8c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a15e4d8c"]])

export default __exports__